<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 :class="{ md4: hasParcel, md6: !hasParcel }">
        <v-card min-height="200">
          <v-card-text>
            <ShipmentAddress
              :title="$t('origin')"
              :address="origin"
              :editable="true"
              :disableEmail="disableEmail"
              :disablePhone="disablePhone"
              addressType="origin"
              @fetch="fetch"
              ></ShipmentAddress>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 :class="{ md4: hasParcel, md6: !hasParcel }">
        <v-card min-height="200">
          <v-card-text>
            <ShipmentAddress
              :title="$t('destination')"
              :address="destination"
              :editable="true"
              :disableEmail="disableEmail"
              :disablePhone="disablePhone"
              addressType="destination"
              @fetch="fetch"
              ></ShipmentAddress>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md4 v-if="hasParcel">
        <v-card min-height="200">
          <v-card-text>
            <ParcelInfo
              :shipment="shipment"
              :editable="true"
              :volumetricWeight="volumetricWeight"
              @fetch="fetch"
              ></ParcelInfo>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import Address from '@/client/address'
import Parcel from '@/client/parcel'
import Setting from '@/client/setting'

import ShipmentAddress from '@/components/shipments/address'
import ParcelInfo from '@/components/parcels/info'

export default {
  name: 'ShipmentInfoComp',

  props: {
    shipment: Object,
    volumetricWeight: String
  },

  data () {
    return {
      settings: [],
      disablePhone: false,
      disableEmail: false
    }
  },

  components: {
    ShipmentAddress,
    ParcelInfo
  },

  computed: {
    origin () {
      return new Address(this.shipment.origin) || new Address()
    },

    destination () {
      return new Address(this.shipment.destination) || new Address()
    },

    hasParcel () {
      return this.shipment.parcels && this.shipment.parcels[0]
    },

    parcel () {
      return new Parcel(this.shipment.parcels[0]) || new Parcel({
        parcel_type: 'box',
        distance_unit: 'cm',
        mass_unit: 'kg'
      })
    }
  },

  methods: {
    fetch () {
      this.$emit('fetch')
    }
  },

  watch: {
  },

  async mounted () {
    this.settings = await Setting.all()

    try {
      this.disableEmail = this.settings.find(o => o.key === `disable_email`).value == '1'
      this.disablePhone = this.settings.find(o => o.key === `disable_phone_number`).value == '1'
    } catch (err) {
      // console.log(err)
    }
  }
}
</script>
